import axios from 'axios';

// Crear una instancia de axios con la configuración base
const axiosInstance = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_URL,
  timeout: 15000, // 15 segundos de timeout
  headers: {
    'Content-Type': 'application/json',
  }
});

// Interceptor para manejar errores globalmente
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // No registrar errores de cancelación en la consola
    if (axios.isCancel(error) || error.name === 'CanceledError' || error.name === 'AbortError') {
      // Crear un error personalizado que no se registre en la consola
      return Promise.reject(error);
    }
    
    // Aquí se pueden manejar errores globales
    console.error('Error en la petición:', error);
    return Promise.reject(error);
  }
);

export default axiosInstance; 